export enum Permiso {

    /* #region Administracion */
    ConsultarAdministracion = "1",
    Exportar = "33",
    /* #endregion */

    /* #region Tablero */
    ConsultarTablero = "2",
    /* #endregion */

    /* #region Modulos */
    AgregarModulo = "3",
    ActualizarModulo = "4",
    EliminarModulo = "5",
    ConsultarModulos = "6",
    /* #endregion */

    /* #region Permisos */
    AgregarPermiso = "7",
    ActualizarPermiso = "8",
    EliminarPermiso = "9",
    ConsultarPermisos = "10",
    /* #endregion */

    /* #region Bitacora */
    ConsultarBitacora = "11",
    /* #endregion */
    
    /* #region Cliente */
    AgregarCliente = "12",
    ActualizarCliente = "13",
    EliminarCliente = "14",
    ConsultarClientes = "15",

    /* #region Usuarios */
    AgregarUsuario = "16",
    ActualizarUsuario = "17",
    EliminarUsuario = "18",
    ConsultarUsuario = "19",
    /* #endregion */

    
    /* #region Servicios */
    AgregarServicio = "20",
    ActualizarServicio = "21",
    EliminarServicio = "22",
    ConsultarServicios = "23",
    /* #endregion */

    /* #region Proveedores */
    AgregarProvedor = "24",
    ActualizarProvedor = "25",
    EliminarProvedor = "26",
    ConsultarProvedores = "27",
    /* #endregion */

    /* #region Roles*/
    AgregarRol = "28",
    ActualizarRol = "29",
    EliminarRol = "30",
    ConsultarRoles = "31",
    /* #endregion */

    /* #region Trnsacciones*/
    ConsultarTransaccioes = "32",
    /* #endregion */

    /* #region Facturas*/
    ConsultarFacturas = "34",
    /* #endregion */
}